import React, {useCallback, useContext, useEffect} from 'react';
import {Switch, Route} from 'react-router-dom';
import {observer} from 'mobx-react';
import Channel from '../Channel/Channel';
import {StoreContext} from '../StoreContext/StoreContext';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher';
import {EChannel} from '../../types/types';
import {autorun} from 'mobx';
import StartPage from '../StartPage/StartPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import {useHistory} from 'react-router-dom';
import './app.scss';

interface IAppProps {}

const App: React.FC<IAppProps> = () => {
    const {channelsStore, errorsStore, filesStore, innerLinksStore, routesStore} = useContext(StoreContext);
    const history = useHistory();

    /* eslint-disable react-hooks/exhaustive-deps */
    const getChannelFileId = useCallback((channelId: EChannel) => {
        const {channels} = channelsStore;
        const channel = channels.filter((channel) => channel.channelName === channelId)[0];
        return channel.files[channel.files.length - 1];
    }, []);

    const loadFile = useCallback((channelId: EChannel) => {
        const {files, loadFile} = filesStore;
        const channelFileID = getChannelFileId(channelId);
        if (!files[channelFileID]) {
            loadFile(channelFileID, channelId);
        }
    }, []);

    const loadRoute = useCallback((routeId: string, channelId: EChannel) => {
        routesStore.loadRoute(routeId, channelId);
    }, []);

    useEffect(() => {
        innerLinksStore.loadInnerLinks();

        history.listen((location) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ym(96776440, 'hit', location.pathname, {
                // title: 'Contact information',
            });
        });
    }, []);

    useEffect(() => {
        if (!channelsStore.channels.length) {
            channelsStore.loadChannels();
        }
    }, [channelsStore]);

    useEffect(() => {
        // Загрузились каналы.
        if (channelsStore.channels.length) {
            Object.values(EChannel).forEach((channelId) => loadFile(channelId));
        }
    }, [channelsStore.channels.length]);

    useEffect(
        () =>
            autorun(() => {
                if (filesStore.channelFileLoaded) {
                    // Загруженный файл.
                    const loadedFile = filesStore.files[filesStore.channelFileLoaded];
                    loadRoute(loadedFile.route, filesStore.channelFileLoaded);
                }
            }),
        []
    );

    return (
        <div className="app">
            <ThemeSwitcher>
                {errorsStore.errors.length ? (
                    <Route path="*" component={ErrorPage} />
                ) : (
                    <Switch>
                        <Route path="/:channelId/" component={Channel} />
                        <Route path="/" component={StartPage} />
                    </Switch>
                )}
            </ThemeSwitcher>
        </div>
    );
};

export default observer(App);
